"use strict";
import React, {Component} from "react";
import {PropTypes, RenderContent, ValueManager} from "Subschema";
import UIPropTypes from '../PropTypes';
import tagManager from '../lib/tagManager.js';

export default class FptiTemplate extends Component {

    static displayName = 'FptiTemplate';

    static contextTypes = {
        requestTracking: UIPropTypes.requestTracking,
		tagData: PropTypes.object
    };

    static propTypes = {
        pgrp: PropTypes.string,
        page: PropTypes.string,
        pros: PropTypes.number,
        tmpl: PropTypes.string
    };

    setPageData = (fptiData, requestTrackingData) => {

        let timeoutId;
        clearTimeout(timeoutId);

        if ( window.PAYPAL && typeof window.PAYPAL.analytics !== 'undefined' &&
             typeof window.PAYPAL.analytics.instance !== 'undefined' ) {

            if (requestTrackingData && requestTrackingData.dataString) {
                var reqDataString = {},
                    i,
                    parts,
                    pairs = requestTrackingData.dataString.split('&');

                for (i = 0; i < pairs.length; i++) {
                     parts = pairs[i].split('=');
                     reqDataString[parts[0]] = decodeURIComponent(parts[1]);
                }

                if (fptiData) {
                    Object.keys(fptiData).map(function(value, index) {
                        reqDataString[value] = fptiData[value];
                    });
                }

                Object.assign(window.fpti || (window.fpti = {}), reqDataString);

            } else if (fptiData) {

                Object.assign(window.fpti || (window.fpti = {}), fptiData);

            }

            window.PAYPAL.analytics.instance.recordImpression();

        } else {

            timeoutId = setTimeout(this.setPageData.bind(null, fptiData, requestTrackingData), 250);

        }
    };

	initTagManager = (fptiData, tagData) => {
		if (tagData) {
			tagData.page = fptiData && fptiData.pgrp;
			tagManager.init(tagData)
		}
	};

    componentDidMount() {
        this.setPageData(this.props, this.context.requestTracking);
		this.initTagManager(this.props, this.context.tagData);
    };

    componentWillReceiveProps(props, context){
        this.setPageData(props, context.requestTracking);
		this.initTagManager(props, context.tagData);
    };

    render() {
        return null;
    }
}



/** WEBPACK FOOTER **
 ** ./src/templates/FptiTemplate.jsx
 **/